import React from 'react'
import ContentSection from '../../../components/ContentSection'
import styled from 'styled-components'
import { Box, Flex } from 'rebass'
import typography from '../../../utils/typography'
import ContentHeadshot from '../../../components/ContentHeadshot'

const FlexWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
`

const FlexWrapperInner = styled(Box)`
  width: 100%;
  max-width: ${(props) => props.theme.content.max.width};
  margin-left: auto;
  margin-right: auto;
`

const HeadshotWidget = ({ items }) => (
  <ContentSection fg="#FFFFFF" bg="#EEF4F9" opacity={0.65} mt={0}>
    <FlexWrapper
      mt={[null, null, typography.rhythm(1)]}
      mb={[typography.rhythm(1), typography.rhythm(2), typography.rhythm(3)]}
      flexWrap="wrap"
    >
      <FlexWrapperInner>
        <ContentHeadshot items={items} />
      </FlexWrapperInner>
    </FlexWrapper>
  </ContentSection>
)

export default HeadshotWidget
